import React from "react";
import { FPTwoBackgroundFullScreenView } from "../../Simple/FPTwoBackgroundFullScreenView/FPTwoBackgroundFullScreenView";
import { FrontColors } from "../../../../models/FrontColors";
import { SpacingRow } from "../../../BuildingBlocks/SpacingRow";
import { FPSimpleLogo } from "../../Simple/FPSimpleLogo/FPSimpleLogo";
import { SpacingColumn } from "../../../BuildingBlocks/SpacingColumn";
import { FPLandingTitle } from "../../Simple/FPLandingTitle/FPLandingTitle";
import { FPMarketingParagraph } from "../../Simple/FPMarketingParagraph/FPMarketingParagraph";
import { FPMarketingHelplineCTA } from "../../Complex/FPMarketingHelplineCTA/FPMarketingHelplineCTA";
import { FPMarketingParagraphColumn } from "../../Complex/FPMarketingParagraphColumn/FPMarketingParagraphColumn";
import { TProbateLeadForm } from "../../../../../../domain/codecs/form/ProbateLeadForm";
import { FrontIcon } from "../../../Front/Simple/FrontIcon/FrontIcon";
import { WeightBold } from "../../../WeightBold/WeightBold";
import { Shape } from "../../../BuildingBlocks/Shape";
import { MaxWidth } from "../../../BuildingBlocks/MaxWidth";
import { Background } from "../../../BuildingBlocks/Background";
import { Sticky } from "../../../BuildingBlocks/Sticky";
import { Padding } from "../../../BuildingBlocks/Padding";
import { Image } from "../../../BuildingBlocks/Image";
import { FPMarketingSectionTitle } from "../../Simple/FPMarketingSectionTitle/FPMarketingSectionTitle";

type TLandingPageDesktopExpertiseProps = {

};

export const FPLandingPageDesktopExpertise = (props: React.PropsWithChildren<TLandingPageDesktopExpertiseProps>): JSX.Element => {

    return (
        <FPTwoBackgroundFullScreenView
            leftColor={FrontColors.PROBATE_0}
            rightColor={FrontColors.PROBATE_0}
            leftCutPoint="50%"
            rightCutPoint="50%"
            height="auto"
        >
            <SpacingRow
                spacing={`79px`}
                childSize="1fr 2px 1fr"
                alignItems="flex-start"
            >
                {/* COLUMN - LEFT */}
                <Background 
                    backgroundPosition={"relative"}
                    padding={`180px 0px 250px`}
                    height="1900px"
                >
                    <Sticky top="180px">
                        <SpacingColumn spacing={`80px`}>
                            <SpacingColumn spacing={`40px`}>
                                <SpacingRow justifyContent="center">
                                    <FrontIcon
                                        iconName="flare"
                                        size={"74px"}
                                        colour={FrontColors.NEUTRAL_18}
                                    />
                                </SpacingRow>
                                
                                <FPLandingTitle 
                                    color={FrontColors.NEUTRAL_18}
                                    align="center"
                                    size={56}
                                >
                                    Keri & Jamie’s Expertise.
                                </FPLandingTitle>
                            </SpacingColumn>

                            <SpacingRow justifyContent="center" spacing="60px">
                                <PersonAvatar url="/static/img/portrait/Keri Expertise 250x250.png" />
                                <PersonAvatar url="/static/img/portrait/Jamie Expertise 250x250.png" />
                            </SpacingRow>
                        </SpacingColumn>
                    </Sticky>
                </Background>

                {/* BORDER */}
                <Background 
                    backgroundPosition={"relative"}
                    padding={`80px 0px 120px`}
                    height="1900px"
                >
                    <Sticky top="80px">
                        <Shape 
                            width="1px"
                            height="700px"
                            color={FrontColors.NEUTRAL_10_2}
                        />
                    </Sticky>
                </Background>

                {/* COLUMN - RIGHT */}
                <Background 
                    padding={`160px 0px 240px`}
                    width="480px"
                    height="1900px"
                >
                    <SpacingColumn spacing="130px">
                        <SpacingColumn spacing={`60px`}>
                            <SpacingRow justifyContent="center">
                                <FrontIcon
                                    iconName="lily"
                                    size={"84px"}
                                    colour={FrontColors.PROBATE_0}
                                />
                            </SpacingRow>

                            <FPMarketingParagraphColumn
                                size={22}
                                spacing="30px"
                                color={FrontColors.NEUTRAL_18}
                                paragraphs={[
                                    <>Together we have over <WeightBold>15 years of experience.</WeightBold>  Helping people like you get probate done.</>,
                                    <>Replacing <WeightBold>uncertainty</WeightBold> with <WeightBold>confidence</WeightBold> on <WeightBold>over 1000</WeightBold> journeys so far.</>,
                                    <>The <WeightBold>biggest</WeightBold> probate service <WeightBold>companies trust us.</WeightBold> Companies like <WeightBold>Zedra,</WeightBold> <WeightBold>Fidelis</WeightBold> and <WeightBold>Prestige</WeightBold> to name a few.</>,
                                ]}
                            />
                        </SpacingColumn>
                    </SpacingColumn>
                    
                    <Sticky top="44px">
                        <Padding spacing="130px 0 0 0px">
                            <SpacingColumn spacing="130px">
                                <SpacingRow justifyContent="center">
                                    <Shape 
                                        width="80px" 
                                        height="2px" 
                                        color={FrontColors.NEUTRAL_18} 
                                    />
                                </SpacingRow>

                                <SpacingColumn spacing="40px">
                                    <FPMarketingSectionTitle
                                        color={FrontColors.NEUTRAL_18}
                                        align="center"
                                    >
                                        Why We Do It?
                                    </FPMarketingSectionTitle>

                                    <FPMarketingParagraphColumn
                                        size={22}
                                        spacing="30px"
                                        color={FrontColors.NEUTRAL_18}
                                        paragraphs={[
                                            <><WeightBold>We have gone through probate ourselves</WeightBold> and understand how hard it can be during this time.</>,
                                            <>Our work has shown us that there is a <WeightBold>big lack of free and simple probate advice online.</WeightBold></>,
                                            <>We started <WeightBold>Sail Probate</WeightBold> to fill this knowledge gap. Making a <WeightBold>free</WeightBold> and <WeightBold>accessible helpline</WeightBold> available to <WeightBold>everyone.</WeightBold> </>,
                                        ]}
                                    />
                                </SpacingColumn>
                            </SpacingColumn>
                        </Padding>
                    </Sticky>
                </Background>

            </SpacingRow>
        </FPTwoBackgroundFullScreenView>
    );
};


const PersonAvatar = (props: { url: string }) => (
    <Image 
        width="150px" 
        height="150px" 
        borderRadius="500px" 
        border={`5px solid ${FrontColors.NEUTRAL_18}`}
        url={props.url}
    />
)